// eslint-disable-next-line no-unused-vars
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSamples } from './Reducers/Sample/Actions';
import { getConfiguration } from './Reducers/Configuration/Actions';
import { loadOptions } from './Reducers/Option/Actions';
import { ConfigurationContext } from './ContextProviders/ConfigurationProvider';
import { globalLoaderStateManager } from './GlobalLoader';

const { watchPromise } = globalLoaderStateManager;

export const InitContainer = ({ children }) => {
  const dispatch = useDispatch();
  const { configuration } = useSelector((state) => state.Configuration);
  const { componentOptions } = useSelector((state) => state.Option);
  const { selectedCountry } = useSelector((state) => state.Country);

  const warehouseConfiguration = useContext(ConfigurationContext);

  useEffect(() => {
    // on country change the component options should be reloaded
    componentOptions.forEach((classification) => {
      classification.options.length = 0;
    });
  }, [componentOptions, selectedCountry]);

  useEffect(() => {
    watchPromise(dispatch(getConfiguration()));
  }, [dispatch, selectedCountry]);

  const itemIdentifier = configuration.item?.identifier;
  useEffect(() => {
    itemIdentifier && watchPromise(dispatch(getSamples(itemIdentifier)));
  }, [dispatch, selectedCountry, itemIdentifier]);

  useEffect(() => {
    if (configuration.code) {
      componentOptions.map(
        (classification) =>
          classification.options.length === 0 &&
          watchPromise(dispatch(loadOptions(classification.key, classification.identifier, configuration)))
      );
      const warehouseData = {
        itemIdentifier: configuration.item.identifier,
        ...configuration.customdata,
      };
      warehouseConfiguration.setData(warehouseData);
    }
  }, [configuration, dispatch]);
  return children;
};
